/**
 * Navigazione piattaforma QCenter — stessa logica di header.blade.php
 * (escluso Live view, perché siamo già in qlive).
 */

export const USER_TIPO = {
    GENERICO: 1,
    SUPERUTENTE: 2,
    FORNITORE: 3,
    CLIENTE: 4,
};

export function isAdmin(tipo) {
    return Number(tipo) === USER_TIPO.SUPERUTENTE;
}

export function isSupplier(tipo) {
    return Number(tipo) === USER_TIPO.FORNITORE;
}

export function isClient(tipo) {
    const t = Number(tipo);
    return t === USER_TIPO.CLIENTE || t === USER_TIPO.GENERICO || t === 0;
}

/**
 * @param {number} userTipo
 * @returns {Array<object>}
 */
export function getPlatformNavItems(userTipo) {
    const items = [];

    if (isAdmin(userTipo) || isSupplier(userTipo)) {
        const children = [];

        if (isAdmin(userTipo)) {
            children.push(
                { label: 'Serials', path: '/seriali', icon: 'SN.png' },
                { label: 'Aliases', path: '/alias', icon: 'CLIENT.png' },
                { label: 'Device types', path: '/tipi_dispositivi', iconSvg: 'barcode-scan.svg' },
                { label: 'Users', path: '/utenti', icon: 'USERS.png' },
                { label: 'Suppliers', path: '/fornitori', icon: 'AIRCRAFT.png' },
                { label: 'Plans', path: '/pianoAbbonamento', icon: 'AIRCRAFT.png' },
                { label: 'Manage configurations', path: '/configurazioni', icon: 'MANAGE.png' },
                { label: 'API Throttle', path: '/throttle', icon: 'MANAGE.png' },
                { label: 'API Statistics', path: '/statistics/api-calls', icon: 'MANAGE.png' },
                { label: 'Live users', path: '/sessioni/live', icon: 'USERS.png' },
                { label: 'Share streaming', path: '/streaming/share', icon: 'MULTI_STREAMING.png' },
                { type: 'divider' },
            );
        }

        children.push(
            { label: 'Clients', path: '/clienti', icon: 'CLIENT.png' },
            { label: 'Aircraft', path: '/velivoli', icon: 'AIRCRAFT.png' },
        );

        items.push({
            id: 'administration',
            label: 'Administration',
            icon: 'ADMINISTRATION.png',
            type: 'dropdown',
            children,
        });
    }

    items.push({ label: 'Missions', path: '/missioni', icon: 'MISSIONI.png' });

    items.push(
        { label: 'Mission Planner', path: '/voli2', icon: 'MISSION_PLANNER.png' },
        { label: 'Streaming', path: '/qstreamingweb/', icon: 'MULTI_STREAMING.png' },
    );

    if (!isClient(userTipo)) {
        items.push({ label: 'Flight plan', path: '/pdv/associa', icon: 'FLIGHT_PLAN.png' });
    }

    if (isAdmin(userTipo)) {
        items.push({ label: 'Data Center', path: '/dataCenter', icon: 'DATA_CENTER.png' });
    }

    return items;
}

export function brandIconUrl(htkBackend, iconFile) {
    const base = (htkBackend || '').replace(/\/+$/, '');
    return `${base}/brandIcons/${iconFile}`;
}

export function platformUrl(htkBackend, path) {
    const base = (htkBackend || '').replace(/\/+$/, '');
    return `${base}${path}`;
}

export function qcenterSvgIconUrl(htkBackend, svgFile) {
    return platformUrl(htkBackend, `/icon/svgs/regular/${svgFile}`);
}

export function qwebLogoUrl(htkBackend) {
    return platformUrl(htkBackend, '/brand/QWEB.png');
}
